module.exports = __webpack_public_path__ + "assets/cwenjian.dd87c85327f0cfcb144b8cd2c4d019dc.png";